<template>
<div class="chapter">
<div class="inner_page">
<figure>
<p class="image2"><span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv"><img alt="Iris Munguía..." height="253" src="images/f0xiv-01.jpg" width="465"/></span></p>
</figure>
<p class="caption">Iris Munguía (COSIBAH), Gloria García (SITRATERCO), Zoila Lagos (COSIBAH), and Domitila Hernández (SITRAESISA), near Omoa, Cortés, Honduras, returning from COSIBAH workshops in Guatemala, November 2002 (left to right).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Image2.vue?34eca18d